<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    what_is_your_travel_arrangement_to_sabah:
        answers?.what_is_your_travel_arrangement_to_sabah,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="mb-3">
            <VInputReadonlyWithBlockLabel
                elId="what_is_your_travel_arrangement_to_sabah"
                v-model:value="form.what_is_your_travel_arrangement_to_sabah"
                :label="
                    surveyFields['what_is_your_travel_arrangement_to_sabah']
                        ?.name
                "
                :isPlainText="false"
            />
        </div>
    </div>
</template>
